/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps } from '@mui/material';

export const cardContentSX: SxProps = {
	'&.MuiCardContent-root': {
		p: 2,
	},
};

export const cardNickSX: SxProps = {
	display: '-webkit-box',
	WebkitBoxOrient: 'vertical',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	WebkitLineClamp: 1,
};

export const cardAddressSX: SxProps = {
	display: '-webkit-box',
	WebkitBoxOrient: 'vertical',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	WebkitLineClamp: 2,
};
